import { getCalendars, getLocales } from "expo-localization";

import {
  type DiagnosticItem,
  DiagnosticStatus,
} from "@/schemas/app/diagnostic";

const fetchLocaleInfo = async (): Promise<DiagnosticItem[]> => {
  const locales = getLocales();
  const calendars = getCalendars();

  const primary = locales[0];
  const calendar = calendars[0];

  return [
    {
      id: "languageCode",
      name: "Language Code",
      value: primary?.languageCode ?? "Unknown",
      status: primary?.languageCode
        ? DiagnosticStatus.OK
        : DiagnosticStatus.WARNING,
    },
    {
      id: "regionCode",
      name: "Region Code",
      value: primary?.regionCode ?? "Unknown",
      status: primary?.regionCode
        ? DiagnosticStatus.OK
        : DiagnosticStatus.WARNING,
    },
    {
      id: "timezone",
      name: "Timezone",
      value: calendar?.timeZone ?? "Unknown",
      status: calendar?.timeZone
        ? DiagnosticStatus.OK
        : DiagnosticStatus.WARNING,
    },
    {
      id: "uses24HourClock",
      name: "Uses 24-Hour Clock",
      value:
        calendar?.uses24hourClock === null
          ? "Unknown"
          : calendar?.uses24hourClock
            ? "Yes"
            : "No",
      status:
        calendar?.uses24hourClock !== null
          ? DiagnosticStatus.OK
          : DiagnosticStatus.WARNING,
    },
    {
      id: "currency",
      name: "Currency",
      value: primary?.currencyCode ?? "Unknown",
      status: primary?.currencyCode
        ? DiagnosticStatus.OK
        : DiagnosticStatus.WARNING,
    },
  ];
};

export default fetchLocaleInfo;
